// Author - Atul Pandey
// First Created - 27 Feb 2025
// Purpose - to feed entity name singulars and plurals for admin setup
// Updated - 26 Jun 2025 - added Habits
// Updated - 19 Aug 2025 - added Assessments
// Updated - 27 Apr 2026 - added OrganizationBUs
// Updated - 27 Apr 2026 - added Accounts
// Updated - 27 Apr 2026 - added AccountContactMaps
// Updated - 06 May 2026 - added userSchedulingPages
// Updated - 26 May 2026 - added sessionQNA
// Updated - 12 Jun 2026 - added orgTrailSessionCohort
// Updated - 19 Aug 2026 - added orgTrailSessionChallengeAssignments
// Updated - 04 Sep 2026 - added orgIntentionBoards
// Updated - 07 Oct 2026 - added orgTrailSessionQNAAssignments
// Updated - 14 Oct 2026 - added Trinity Meeting Board
// Updated - 29 Oct 2026 - Coach Evaluation Framework


const entityNameMap = {
    users: ["user", "users"],
    orgUsers: ["orgUser", "orgUsers"],
    userSchedulingPages: ["userSchedulingPage", "userSchedulingPages"], // 06 May 2026

    // 29 Oct 2026 - Coach Evaluation Framework
    evaluationFramework: [
        'evaluationFramework',
        'evaluationFrameworks',
    ],

    // 14 Oct 2026
    trinityMeetings: [
        "trinityMeeting",
        "trinityMeetings",
    ],

    userImprintEts: ["userImprintEt", "userImprintEts"],
    assessments: ["assessment", "assessments"],                            // 19 Aug 2025
    coachUserPads: ["coachUserPad", "coachUserPads"],
    sponsorUserPads: ["sponsorUserPad", "sponsorUserPads"],
    challenges: ["challenge", "challenges"],


    // 08 Sep 2026
    orgIgniterIntentionBoards: [
        "orgIgniterIntentionBoard",
        "orgIgniterIntentionBoards"
    ],

    // 04 Sep 2026
    orgIntentionBoards: [
        "orgIntentionBoard",
        "orgIntentionBoards"
    ],

    // 19 Aug 2026
    orgTrailSessionChallengeAssignments: [
        "sessionChallengeAssignment",
        "sessionChallengeAssignments",
    ],

    // 07 Oct 2026
    orgTrailSessionQNAAssignments: [
        "sessionQNAAssignment",
        "sessionQNAAssignments",
    ],

    // 08 Oct 2026
    sessionReferenceContents: [
        "sessionReferenceContent",
        "sessionReferenceContents",
    ],

    // 08 Oct 2026
    orgTrailSessionContentAssignments: [
        "sessionContentAssignment",
        "sessionContentAssignments",
    ],



    contacts: ["contact", "contacts"],
    challengeHeads: ["challengeHead", "challengeHeads"],
    contactOrganizations: ["contactOrganization", "contactOrganizations"],
    habits: ["habit", "habits"],                            // 26 Jun 2025
    organizations: ["organization", "organizations"],
    organizationBUs: ["organizationBU", "organizationBUs"], // 27 Apr 2026
    accounts: ["account", "accounts"], // 27 Apr 2026
    accountContactMaps: ["accountContactMap", "accountContactMaps"], // 27 Apr 2026
    sessionQNAs: ["sessionQNA", "sessionQNAs"], // 26 May 2026
    orgRoles: ["orgRole", "orgRoles"],
    orgTitles: ["orgTitle", "orgTitles"],
    questionSets: ["questionSet", "questionSets"],
    questions: ["question", "questions"],
    questionWithScores: ["questionWithScore", "questionsWithScores"],
    sections: ["section", "sections"],
    subsPacks: ["subsPack", "subsPacks"],
    orgSubscriptions: ["orgSubscription", "orgSubscriptions"],
    sessions: ["session", "sessions"],
    trails: ["trail", "trails"],
    
    orgTrailSessionCohorts: ["orgTrailSessionCohort", "orgTrailSessionCohorts"], // 12 Jun 2026
        
    actionTypes: ["actionType", "actionTypes"],
    capabilitiesAdvisoryTypes: ["capabilitiesAdvisoryType", "capabilitiesAdvisoryTypes"],
    capabilitiesDomainTypes: ["capabilitiesDomainType", "capabilitiesDomainTypes"],
    capabilitiesFunctionTypes: ["capabilitiesFunctionType", "capabilitiesFunctionTypes"],
    capabilitiesIndustryTypes: ["capabilitiesIndustryType", "capabilitiesIndustryTypes"],
    capabilitiesSalesFunctionAreaTypes: ["capabilitiesSalesFunctionAreaType", "capabilitiesSalesFunctionAreaTypes"],
    capabilitiesSalesTypes: ["capabilitiesSalesType", "capabilitiesSalesTypes"],
    capabilitiesServiceFunctionAreaTypes: ["capabilitiesServiceFunctionAreaType", "capabilitiesServiceFunctionAreaTypes"],
    capabilitiesServiceTypes: ["capabilitiesServiceType", "capabilitiesServiceTypes"],
    capabilitiesSoftSkillFunctionAreaTypes: ["capabilitiesSoftSkillFunctionAreaType", "capabilitiesSoftSkillFunctionAreaTypes"],
    capabilitiesSoftSkillTypes: ["capabilitiesSoftSkillType", "capabilitiesSoftSkillTypes"],
    capabilitiesTechAreaTypes: ["capabilitiesTechAreaType", "capabilitiesTechAreaTypes"],
    capabilitiesTechStackTypes: ["capabilitiesTechStackType", "capabilitiesTechStackTypes"],
    challengeTypes: ["challengeType", "challengeTypes"],
    contactOrganizationTypes: ["contactOrganizationType", "contactOrganizationTypes"],
    contactTypes: ["contactType", "contactTypes"],
    contributionTypes: ["contributionType", "contributionTypes"],
    creationAreaTypes: ["creationAreaType", "creationAreaTypes"],
    creationTypes: ["creationType", "creationTypes"],
    gratitudeTypes: ["gratitudeType", "gratitudeTypes"],
    goalTypes: ["goalType", "goalTypes"],                   // 11 Aug 2025
    impactTypes: ["impactType", "impactTypes"],
    inspirationBeaconTypes: ["inspirationBeaconType", "inspirationBeaconTypes"],
    intentionTypes: ["intentionType", "intentionTypes"],
    investigationTypes: ["investigationType", "investigationTypes"],
    legacyTypes: ["legacyType", "legacyTypes"],
    missionMetricGradationTypes: ["missionMetricGradationType", "missionMetricGradationTypes"],
    missionMetricUoMTypes: ["missionMetricUoMType", "missionMetricUoMTypes"],
    organizationTypes: ["organizationType", "organizationTypes"],
    problemAreaTypes: ["problemAreaType", "problemAreaTypes"],
    problemMetricGradationTypes: ["problemMetricGradationType", "problemMetricGradationTypes"],
    problemMetricTypes: ["problemMetricType", "problemMetricTypes"],
    problemMetricUoMTypes: ["problemMetricUoMType", "problemMetricUoMTypes"],
    sessionTypes: ["sessionType", "sessionTypes"],
    showcaseTypes: ["showcaseType", "showcaseTypes"],
    userChallengeTypes: ["userChallengeType", "userChallengeTypes"],
    winTypes: ["winType", "winTypes"],    
};

export default entityNameMap;